import { parseDuration } from "util/datetime";
import Indicador from "..";
import TTCEditFields from "./components/TTCEditFields";
import { TTCParamFields } from "./components/TTCParamFields";
import ttcReport from "./reports";
import ttcReportSummary from "./reports/summary";
import { compareOp } from "util/lang";
import _ from 'lodash'
// import TTCGraficoPainel from "./components/TTCGraficoPainel";
// import TTCGraficoRelatorio from "./components/TTCGraficoRelatorio";

export default class TTC extends Indicador {
    static get fullName() {
        return "Tempo de Transbordamento de Cana";
    }

    static get abbrev() {
        return "TTC";
    }

    static get legacyApontamentoMap() {
        return {
            dataHora: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            frente: "frente",

            operador: "operador",
            turno: "turno",
            georeferencia: "georeferencia",
            tempoRegistrado: "tempoRegistrado",

            conformidadeAmostra: "conformidade",
            resto: "resto",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {
            metaTTCManual: "manual.meta",

            metaTTCMecanizado: "mecanizado.meta",

            classificacaoTTC: {
                type: Array,
                newField: "items",
                paramMap: {
                    classificacao: "classificacao",
                    valorMinimo: "intervaloMin",
                    valorMaximo: "intervaloMax",
                    sinalIntervaloMin: "sinalIntervaloMin",
                    sinalIntervaloMax: "sinalIntervaloMax",
                },
            },
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <TTCParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <TTCEditFields visita={visita} isNew={isNew} TipoClass={TipoClass} />
    }

    // static getGraficoPainel(mediaAgrupadorList, fullName, nomeAgrupador, meta) {
    //     return <TTCGraficoPainel mediaAgrupadorList={mediaAgrupadorList} fullName={fullName} nomeAgrupador={nomeAgrupador} meta={meta} />
    // }

    // static getGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro) {
    //     return TTCGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
    // }

    async renderReport(visita) {
        return ttcReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ttcReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!params
            || apontamento.tempoRegistrado === undefined
            || apontamento.tempoRegistrado.includes("_")
        ) {
            apontamento.resto = undefined
            return 0;
        }

        const meta = parseDuration(params.meta);
        const tempo = parseDuration(apontamento.tempoRegistrado);
        apontamento.tempoRegistradoSegundos = parseDuration(apontamento.tempoRegistrado);

        if (meta && tempo) {
            apontamento.resto = (tempo - meta).toFixed(0);
        }

        return ((100 * f(apontamento.resto)) / meta).toFixed(2)

    }

    static getConformidadeStatus(conformidade, meta, apontamento, cliente) {
        if (!cliente) {
            throw new Error(
                "Este indicador necessita dos dados do cliente para calcular o status de conformidade"
            );
        }

        let cliParam
        if (cliente.getAllParams) {
            cliParam = cliente.getAllParams(this)
        } else if (cliente.params) {
            cliParam = _.get(cliente.params, this.abbrev.toLowerCase())
        }

        if (!cliParam || !cliParam.items || !cliParam.items.length) {
            return this.calcConformidadeStatusInverte(conformidade, 100, 30, 20, 10)
        }

        let itensStatus = cliParam?.items || []

        let metaTime

        if (typeof meta === "number") {
            metaTime = meta
        } else {
            metaTime = parseDuration(meta)
        }

        let cofTime = metaTime * (parseFloat(conformidade) + 100) / 100



        const veri = (item) => {

            const result1 = compareOp(cofTime, item.sinalIntervaloMin, parseDuration(item.intervaloMin));
            const result2 = compareOp(cofTime, item.sinalIntervaloMax, parseDuration(item.intervaloMax));

            if (item.intervaloMin && !item.intervaloMax) {
                return result1;
            } else if (item.intervaloMax && !item.intervaloMin) {
                return result2;
            } else {
                return result1 && result2;
            }
        }
        for (const item of itensStatus) {

            if (veri(item)) {
                // console.log('axo', item)
                return item.classificacao
            }


        }



        return "ERROR"
        // return this.calcConformidadeStatusInverte(conformidade, 100, 30, 20, 10);
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },
            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Implemento", field: "implemento.numeroFrotaImplemento", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Operador", field: "operador", width: 'auto' },


            { title: "Tempo Registrado (mm:ss) ", field: "tempoRegistrado", width: 'auto' },//
            { title: "Resto (segundos)", field: "resto", width: 'auto' },//


            {
                title: "% ", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta, a, paramsCliente))
                }
            },

        ]
    }

    static getResultStr(apontamento) {
        return "Tempo Registrado (mm:ss): " + apontamento.tempoRegistrado +
            " e Resto (segundos): " + apontamento.resto
    }
}
